module.exports = __webpack_public_path__ + "img/branch-particle-06.a57612a8.png";